import createUseStyles from '@eduzz/houston-styles/createUseStyles';

const useStyles = createUseStyles((theme) => ({
  saveButtonDiv: {
    '& .helper-text': {
      marginBottom: 12,
    },
  },
  draftButton: {
    marginRight: 8,
  },
  saveButton: {
    display: 'flex',
    justifyContent: 'flex-end',
  },

  infoReadyToSell: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 4,
    fontSize: 13,
    color: theme.brandColor.primary.dark,
    fontSmooth: 'antialiased',
    fontWeight: 700,
    '& svg': {
      fill: '#ffcd33',
    },
  },
}));

export default useStyles;
